import $ from 'jquery';

class HeaderScroll {
    constructor (minHeight) {
        this.logoSelector = 'header .brand img';
        this.headerSelector = 'header';
        this.contentContainerSelector = '#wrapper';
        this.minHeightContainerSelector = 'header .header-wrapper';
        this.originalHeight = 0;
        this.minHeight = null;
        if (minHeight) {
            this.minHeight = minHeight;
        }
        $(document).ready(() => {
            const $logo = $(this.logoSelector);
            $logo.on('load', () => {
                this.setHeightBasedOnScroll();
            });
        });
        $(window).on('scroll', () => {
            this.setHeightBasedOnScroll();
        });
    }

    setHeightBasedOnScroll() {
        this.initJQueryElements();
        this.setMaxHeightForLargeWidthLogos();
        if (this.minHeight === null) {
            this.minHeight = parseInt($(this.minHeightContainerSelector).css('min-height'));
        }
        const originalHeight = this.getOriginalHeight();
        const position = $('body').scrollTop();
        let height = originalHeight - position;
        if (height < this.minHeight) {
            height = this.minHeight;
        }
        this.$logo.height(height);
        const headerHeight = this.$header.height();
        if (headerHeight === this.minHeight) {
            height = this.minHeight;
        }
        if (height < this.minHeight) {
            height = this.minHeight;
        }
        this.$logo.height(height);
        this.setWrapper();
    }

    setMaxHeightForLargeWidthLogos() {
        const maxWidth = parseInt(this.$logo.css('max-width'));
        const width = this.$logo.width();
        if (width >= maxWidth) {
            this.$logo.css('max-height', this.$logo.height());
        }
    }

    setWrapper() {
        const $contentContainer = $(this.contentContainerSelector);
        let headerHeight = this.$header.height();
        if (headerHeight < this.minHeight) {
            headerHeight = this.minHeight;
        }
        $contentContainer.css('padding-top', headerHeight);
        this.$header.css('position', 'fixed');
    }

    getOriginalHeight() {
        let originalHeight = this.originalHeight;
        if (originalHeight === 0) {
            originalHeight = this.$logo.height();
            if (originalHeight === 0) {
                originalHeight = parseInt(this.$logo.css('max-height'));
            } else {
                this.originalHeight = originalHeight;
            }
        }
        return originalHeight;
    }

    initJQueryElements() {
        this.$logo = $(this.logoSelector);
        this.$header = $(this.headerSelector);
    }
}

export default HeaderScroll;
